import _ from "lodash"
import { GAME_KEYS } from "@/store/game/game.constants"
import {
  COACH_SEARCH_FILTERS,
  COACH_SEARCH_SORT_OPTIONS,
} from "@/store/coaching/coaching.constants"
import { searchCoachesForGame } from "@/api/coaching"

const state = {
  availableCoaches: null,
}

const mutations = {
  SET_AVAILABLE_COACHES: (state, availableCoaches) => {
    state.availableCoaches = availableCoaches
  },
}

const actions = {
  async loadAllAvailableCoaches ({ state, commit, dispatch, rootGetters }, forceReload) {
    forceReload = forceReload || false
    if (!forceReload && state.availableCoaches !== null) {
      return
    }

    await Promise.all([
      dispatch("User/Coaching/loadInstaProAccessToken", null, { root: true }),
      dispatch("Coaching/loadInstaProGames", null, { root: true }),
    ])
    const instaProAccessToken = rootGetters["User/Coaching/getInstaProAccessToken"]
    const instaProGamesByKey = rootGetters["Coaching/gamesByKey"] || {}
    const gameId = (instaProGamesByKey[GAME_KEYS.SSBU] || {}).id || null
    if (!gameId) {
      return
    }

    let coachList = []
    let page = 0
    let nextPageUrl = null
    do {
      const coachSearchData = await searchCoachesForGame(
        instaProAccessToken,
        gameId,
        ++page,
        COACH_SEARCH_SORT_OPTIONS.AVAILABLE_FIRST,
        [],
        null,
        [COACH_SEARCH_FILTERS.ONLINE_OR_HAS_OPEN_SCHEDULE_SLOTS]
      )

      const coaches = coachSearchData?.result?.data || []
      coachList.push(...coaches)
      nextPageUrl = coachSearchData?.result?.next_page_url || null
    } while (nextPageUrl !== null)

    commit("SET_AVAILABLE_COACHES", coachList)
    Promise.all(coachList.map(coach => dispatch("Coaching/saveCoach", coach, { root: true })))
  },
}

const getters = {
  getCoachesForCharacter: (state, getters, rootState, rootGetters) => characterName => {
    const instaProGamesByKey = rootGetters["Coaching/gamesByKey"] || {}
    const gameId = (instaProGamesByKey[GAME_KEYS.SSBU] || {}).id || null
    const coaches = state.availableCoaches || []
    return coaches.filter(coach => {
      const coachGames = coach.games || []
      const coachGameData = coachGames.find(game => game.game_id === gameId)
      const specializationItems = coachGameData?.specialization_items || {}
      const specializedCharacters = _.flow([_.values, _.flatten, _.uniq])(specializationItems)
      return specializedCharacters.includes(characterName)
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/coaching/games/ssbu/ssbu.module.js